import React from 'react';

function ConditionalRenderer({
    allowedProjects, disallowedProjects, currentProject,
    allowedTypes, disallowedTypes, currentType, children,
}) {
    if (currentProject && (
        (allowedProjects && !allowedProjects.includes(currentProject))
        || disallowedProjects?.includes(currentProject)
    )) {
        return null;
    }

    if (currentType && (
        (allowedTypes && !allowedTypes.includes(currentType))
        || disallowedTypes?.includes(currentType)
    )) {
        return null;
    }

    return children;
}

export default React.memo(ConditionalRenderer);
